import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

/** Rough S3 DNS-style bucket name (3–63 chars, lowercase alnum + dots/hyphens). */
const validateBucketName = (raw: string): string | undefined => {
  const bucketName = raw.trim();
  if (!bucketName) return "S3 bucket name is required.";
  const bucketPattern = /^[a-z0-9][a-z0-9.-]{1,61}[a-z0-9]$/;
  if (!bucketPattern.test(bucketName)) {
    return "Bucket name must be a valid S3 bucket DNS name (lowercase letters, numbers, dots, hyphens).";
  }
  return undefined;
};

export const FileTransferComponents = InstallSpec({
  "iam-write": ItemComponent({
    type: "dynamic",
    label: "File transfer access control",
    description:
      "Allows P0 to provide file transfer access. Only AWS accounts with SSH (iam-write) installed are shown.",
    maturity: "beta",
    schema: {
      bucketName: Element({
        label: "S3 bucket name",
        description:
          "Customer bucket for fast file transfers (no s3:// prefix), the bucket must be in the same AWS account, but can be in a different region.",
        type: "string",
        validator: async (_id, value) => validateBucketName(value),
      }),
      region: Element({
        label: "Bucket region",
        description: "AWS region of the bucket (e.g. us-east-1)",
        type: "hidden",
      }),
      awsPartition: Element({
        label: "AWS partition",
        description: "Usually aws; use aws-us-gov for GovCloud",
        type: "hidden",
      }),
    },
  }),
});
